<form #userForm="ngForm" (ngSubmit)=onSubmit(userForm) class="m-auto auth auth-background">
    <div class="container-fluid">
      <div class="row  justify-content-center align-items-center h-100">
        <div class="login-card">
        <div class="col-12 text-center">
          <h3 class="login-label mb-5">Create your Profile</h3>
          <div class="profile-pics position-relative">
            <img [src]="defaultPic" alt="profile pic" height="180px" width="180px">
            <span class="profile-edit"> <i class="fa fa-edit fs-24"  data-toggle="modal" data-target="#categoryModal"></i></span>
          </div>
        </div>
        <div class=" card-input col-md-12 col-xl-12 ">
            <div class="form-group mb-1 mt-4">
                <span> <i class="fa fa-user text-white input-icon" aria-hidden="true"></i></span>
                <input type="text" [(ngModel)]="profile.profile_name" class="form-control pl-5" maxlength="20" name="profile_name" #profile_name="ngModel"
                  placeholder="Name"   required>
                </div>
                <div *ngIf="userForm.submitted && profile_name.invalid" class="text-left mt-0">
                  <p class="error-msg mb-0">{{ 'FORMERROR.USERNAME' | translate  }}</p>
            </div>
           <div class="secure-pin mt-3">
          <div class="radio">
        <input
      type="radio"
      class="radio-input"
      [checked]="isSecure"
      (click)="onSecureRadioClick($event)"
    />
    Secure My Profile
  </div>
</div>
           
            <div class="col-12 pb-4 d-flex justify-content-center text-center mt-5">
                <button class="btn btn-secondary login-back mr-5" type="button" (click)="back()">Back</button>
                
                <button class="login-btns login-with-code btn" type="submit" [disabled]="isSubmitting">
                <div class="server-login-dis">
                {{ isSubmitting ? 'Submitting...' : 'Submit' }}
                </div>
                </button>
              </div>
        </div>
        </div>
        </div>
    </div>
</form>



<!-- PIN Setup Modal -->
<div class="modal" tabindex="-1" [ngClass]="{'d-block': showPinModal}" style="background-color: rgba(0, 0, 0, 0.76);">
  <div class="modal-dialog modal-sm custom-modal-dialog modal-dialog-centered">
    <div class="modal-content custom-content p-3">
      <div class="modal-header custom-header">
        <h5 class="modal-title">Set PIN</h5>
        <button type="button" class="close" (click)="cancelPin()">&times;</button>
      </div>
      <div class="modal-body custom-body">
       
<div class="form-group text-center mt-3">
  <label>Enter Pin</label>
  <div class="d-flex justify-content-center">
    <input
      *ngFor="let digit of pinDigits; let i = index"
      [(ngModel)]="enteredPinArray[i]"
      maxlength="1"
      class="form-control text-center otp-input enter-pin"
      (input)="onDigitInput($event, i, 'enter')"
      (keydown)="onKeyDown($event, i, 'enter')"
      inputmode="numeric"
      pattern="[0-9]*"
      type="password"
    />
  </div>
</div>

<!-- Re-enter PIN -->
<div class="form-group text-center mt-3">
  <label>Re-Enter Pin</label>
  <div class="d-flex justify-content-center">
    <input
      *ngFor="let digit of pinDigits; let i = index"
      [(ngModel)]="reEnteredPinArray[i]"
      maxlength="1"
      class="form-control text-center otp-input reenter-pin"
      (input)="onDigitInput($event, i, 'reenter')"
      (keydown)="onKeyDown($event, i, 'reenter')"
      inputmode="numeric"
      pattern="[0-9]*"
      type="password"
    />
  </div>
</div>
<div class="text-danger  text-center" *ngIf="pinError">PINs do not match</div>
</div>
      <div class="modal-footer custom-footer">
        <button class="btn cancel-btn" (click)="cancelPin()">Cancel</button>
        <button class="btn set-btn" (click)="savePin()">Set</button>
      </div>
    </div>
  </div>
</div>

<div class="modal right fade" id="categoryModal" tabindex="-1" role="dialog" aria-labelledby="categoryModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header" style="position: sticky;top: 0;">
        <h5 class="modal-title pl-3" id="categoryModal">Choose your Profile</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
      <div class="rows cat-item d-flex justify-content-start align-item-center" *ngFor="let item of categories; index as i" >
        <div class="rows cat-item d-flex justify-content-start align-item-center"  >
        <div class="cat-width" >
          <div class="categories-name" >{{item.name}}</div>
          <div class="categories d-flex">
            <div class="profile p-2" *ngFor="let items of item.items" (click)="selectedProfilePic(items)">
              <div class="profile-image">
                <img [src]="items.imageUrl"  alt="profile-pic" class="img" >
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>